import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]定投收益
 */
export function queryAIPPerformUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcAipPerform> {
  return resource.postNoAuth('/normalFund/queryAIPPerform', req, config);
}

/**
 * [Auth]买卖点
 */
export function queryBuyAndSellPointUsingPOST_3(
  req: InfoCodeClientDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcBuySellPoint> {
  return resource.post('/normalFund/queryBuyAndSellPoint', req, config);
}

/**
 * [No Auth]各种基金基本信息
 */
export function queryFundBaseInfoUsingPOST_3(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultFundInfoDto> {
  return resource.postNoAuth('/normalFund/queryFundBaseInfo', req, config);
}

/**
 * [No Auth]基金档案外部
 */
export function queryFundInfoUsingPOST_3(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultFundInfoDto> {
  return resource.postNoAuth('/normalFund/queryFundInfo', req, config);
}

/**
 * [No Auth]基金经理
 */
export function queryFundManagerInfoUsingPOST_3(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultListFundManagerInfoDto> {
  return resource.postNoAuth('/normalFund/queryFundManagerInfo', req, config);
}

/**
 * [No Auth]基金页面类型
 */
export function queryFundPageTypeUsingPOST_4(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultFundPageTypeDto> {
  return resource.postNoAuth('/normalFund/queryFundPageType', req, config);
}

/**
 * [No Auth]产品概要
 */
export function queryFundProfileUsingPOST_4(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultLcAnnouncement> {
  return resource.postNoAuth('/normalFund/queryFundProfile', req, config);
}

/**
 * [No Auth]阶段涨幅
 */
export function queryFundReturnPerformUsingPOST_1(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcFundReturnRank> {
  return resource.postNoAuth('/normalFund/queryFundReturnPerform', req, config);
}

/**
 * [No Auth]指数列表
 */
export function queryIndexListUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcIndexDto> {
  return resource.postNoAuth('/normalFund/queryIndexList', req, config);
}

/**
 * [No Auth]指数走势
 */
export function queryIndexReturnTrendUsingPOST(
  req: InfoPeriodDto | void,
  config?: RequestConfig
): Promise<ApiResultListTrendDto> {
  return resource.postNoAuth('/normalFund/queryIndexReturnTrend', req, config);
}

/**
 * [No Auth]净值估算
 */
export function queryNetValueEstimateUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcNetValueEstimate> {
  return resource.postNoAuth('/normalFund/queryNetValueEstimate', req, config);
}

/**
 * [No Auth]历史净值
 */
export function queryNetValueHistUsingPOST(
  req: InfoPageDto | void,
  config?: RequestConfig
): Promise<ApiResultPageLcNetValue> {
  return resource.postNoAuth('/normalFund/queryNetValueHist', req, config);
}

/**
 * [No Auth]净值走势
 */
export function queryNetValueTrendUsingPOST(
  req: InfoPeriodDto | void,
  config?: RequestConfig
): Promise<ApiResultNetValueTrendDto> {
  return resource.postNoAuth('/normalFund/queryNetValueTrend', req, config);
}

/**
 * [No Auth]产品宣传图链接
 */
export function queryPublicityPictureUrlUsingPOST_3(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultstring> {
  return resource.postNoAuth('/normalFund/queryPublicityPictureUrl', req, config);
}

/**
 * [No Auth]申购费率
 */
export function queryRedemptionRateUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultLcChargeRate> {
  return resource.postNoAuth('/normalFund/queryRedemptionRate', req, config);
}

/**
 * [No Auth]业绩走势
 */
export function queryYieldTrendUsingPOST(
  req: InfoPeriodDto | void,
  config?: RequestConfig
): Promise<ApiResultYieldTrendDto> {
  return resource.postNoAuth('/normalFund/queryYieldTrend', req, config);
}

/**
 * [No Auth]阅读文件留痕
 */
export function addFundLeaveMarksUsingPOST_3(req: LcFundLeaveMarks | void, config?: RequestConfig): Promise<void> {
  return resource.postNoAuth('/normalFund/saveFundLeaveMarks', req, config);
}

/**
 * [No Auth]根据产品代码查询产品文件路径
 */
export function searchFindFileUsingPOST_3(
  req: SearchFindFileParam | void,
  config?: RequestConfig
): Promise<ApiResultListLcFundFilePathVo> {
  return resource.postNoAuth('/normalFund/searchFindFile', req, config);
}
